import { RegionOutageType } from "./ShutdownAddPageTypes";

export type ShutdownTablePayloadRow = {
  region_id: number;
  outages_type: number;
};

/** One API row per region/outage type; drops duplicate type ids within a region. */
export function buildShutdownTablePayload(
  regionOutages: RegionOutageType[],
): ShutdownTablePayloadRow[] {
  const data_to_send: ShutdownTablePayloadRow[] = [];

  regionOutages.forEach((regionoutage) => {
    const seenTypes = new Set<number>();
    regionoutage.outages_types.forEach((outageType) => {
      if (seenTypes.has(outageType)) {
        return;
      }
      seenTypes.add(outageType);
      data_to_send.push({
        region_id: regionoutage.region_id,
        outages_type: outageType,
      });
    });
  });

  return data_to_send;
}
